import { render, staticRenderFns } from "./AppStructure.vue?vue&type=template&id=38c1cefa"
import script from "./AppStructure.vue?vue&type=script&lang=js"
export * from "./AppStructure.vue?vue&type=script&lang=js"
import style0 from "./AppStructure.vue?vue&type=style&index=0&id=38c1cefa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports